    <template>
    <v-card flat style="min-height:20vh;overflow-x:scroll;box-shadow: 0px 0px 44px rgba(0, 0, 0, 0.04);border-radius: 10px;">
        <v-card-title class="subheading"><strong>Styles</strong>
        &nbsp;
        <v-chip v-if="styles.length>0" class="amber white--text">
            {{styles.length}} styles
        </v-chip>
        <v-spacer/>
        <v-text-field 
                    class="style-input mr-2"
                    hide-details
                    dense
                    height="30"
                    label="Search for style ..."
                    single-line
                    style="height:25px;padding:0px;margin:0px"
                    type="text"
                    @change="styleSearch"
                    v-model="styleNum"
                    append-icon="search"
                   @click:append="styleSearch"
                  />
        </v-card-title>
        <hr>
        <v-card-text v-if="loading">
            <v-container v-if="loading" >
                 <v-progress-circular
                    v-if="loading"
                    :size="100"
                    :width="15"
                    color="purple"
                    valvue="Loading"
                    indeterminate
                    ></v-progress-circular>
            </v-container>
        </v-card-text>
        <v-card-text v-if="styles.length>0  " style="height:200px;overflow-y:scroll" >
            <v-layout row wrap style="min-height:50px">
                <v-flex xs12 class="white">
                    <template v-for="style in styles">
                    <v-card outline style="margin-bottom:5px;border-left:5px solid purple;border-right:2px solid purple;">
                    <v-card-text >
                        <v-layout row wrap>
                            <v-flex xs1>
                                <v-img v-if="style.image" style="cursor:hand" 
                                @click="showImageDialog(style.image)" 
                                :src="style.image"
                                width="48" height="48px"/>
                            </v-flex>
                            <v-flex xs3>
                             <strong> {{style.item_num_display}}</strong><br/>
                             <small>{{style.description_long}}</small><br/>
                             <span class="green--text"><small>{{style.UPC_NUM}}</small></span>
                            </v-flex>
                            <v-flex xs2>
                                <v-layout row wrap>
                                    <v-flex xs5><strong>Whse</strong></v-flex>
                                    <v-flex xs2 class="text-xs-right">{{style.warehouse_id}}</v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs5><strong>Stock</strong></v-flex>
                                    <v-flex xs2 class="text-xs-right">{{style.qty_on_hand}}</v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs5><strong>ATS</strong></v-flex>
                                    <v-flex xs2 class="text-xs-right">{{style.ats}}</v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs3>
                                 <v-layout row wrap>
                                    <v-flex xs5><strong>Selling Price</strong></v-flex>
                                    <v-flex xs7>${{(style.sell_price ? style.sell_price.toFixed(2) : '')}}</v-flex>
                                </v-layout>
                                 <v-layout row wrap>
                                    <v-flex xs5><strong>Cost</strong></v-flex>
                                    <v-flex xs7>
                                        <span v-if="user_type!='S'" >   ${{style.cost ? style.cost.toFixed(2) : ''}}</span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs1>
                             <strong> Shipment@ {{style.next_shipment}}</strong>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    </v-card>
                    </template>
                </v-flex>
            </v-layout>
        </v-card-text>
             <v-card-actions>   
                    <template v-for="preference in preferences">
                        <v-chip @click="chipClicked(preference)" @input="removeSearch(preference) " small close class="pink white--text">
                            {{preference}}
                        </v-chip> &nbsp;
                    </template>
                    </v-card-actions>
        <v-dialog width="50%" v-model="imageDialog" >
             <v-card>
                <v-container
                fluid
                grid-list-md
                >
                <v-img :src="largeImage" />
                           
                </v-container>
           
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
//import SalesAnalysisModel from '../../api/service/SalesAnalysisService.js'
import DashboardService from '@/api/service/DashboardService.js'
export default {
      components: {
      },
      data () {
          return {
              role:"",
              user_type:"",
              options:{},
              dataset: [],
              loading:false,
              styleNum:"",
              preferences: [],
              imageDialog:false,
              largeImage:"",
              imagePath:"",
              styles: [
                  
              ]

          }
      },
      created()  {
          this.getPreferences()
      },
      mounted() {
        
      },
      methods: {
          chipClicked($style) {
            this.styleNum = $style
            this.styleSearch()
          },
          showImageDialog($image) {
              this.imageDialog=true
              this.largeImage=$image
          },
          removeSearch(preference) {
              this.preferences.splice(this.preferences.indexOf(preference),1)
              var $localStorage =JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
              $localStorage.data.preferences.styleWatch = this.preferences
              localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE,JSON.stringify($localStorage))
              if(this.preferences.length>0) {
                this.styleNum = this.preferences[this.preferences.length-1]
                this.styleSearch()
             }
          },
          getPreferences() {
            var $localStorage =JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
            this.imagePath = $localStorage.data.User.company.imagePath
            this.role = $localStorage.data.User.role
            this.user_type = $localStorage.data.User.user_type
            if($localStorage.data.preferences) {
                if($localStorage.data.preferences.styleWatch) {
                    //this.styleSearch($localStorage.data.prefrences.styleWatch)
                    this.preferences = $localStorage.data.preferences.styleWatch
                    if(this.preferences.length>0) {
                        this.styleNum = this.preferences[this.preferences.length-1]
                        this.styleSearch()
                    }
                }
            }
          },
          styleSearch() {
              this.loading=true
              var $search = this.styleNum
              /*if(this.preferences)  {
                  //this.preferences.push({"id":this.styleNum,"name":this.styleNum})
                  this.preferences.push(this.styleNum)
              }*/
              var $localStorage = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
               if(!$localStorage.data.preferences) {
                   $localStorage.data.preferences={styleWatch:[]}
               } else {
                   if(!$localStorage.data.preferences.styleWatch) {         
                        $localStorage.data.preferences.styleWatch=[]
                   }
               }
              if(this.styleNum.indexOf(',')>=0) {
                  var $search = $search.split(',')
                  $localStorage.data.preferences.styleWatch.concat($search)
              } else {
                  if($localStorage.data.preferences.styleWatch.indexOf(this.styleNum)<0) {
                    $localStorage.data.preferences.styleWatch.push(this.styleNum)
                  }
              }
              //$search = $localStorage.data.preferences.styleWatch
              this.preferences =$localStorage.data.preferences.styleWatch
              localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE,JSON.stringify($localStorage))
              DashboardService.getStyleLookup({"ITEM_NUM_DISPLAY":$search.toUpperCase()})
                .then($styles => {
                    this.styles = $styles.data

                    this.loading=false
                })
          },
          /*format = function(n) {
            return this.toFixed(Math.max(0, ~~n));
            },*/
            round(value, decimals) {
                return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
            },
          setPreferences() {
              var $localStorage =localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)
              if($localStorage.data.preferences) {
                $localStorage.data.preferences = {}     
              } 
              if($localStorage.data.prefrences.styleWatch) {
               $localStorage.data.preferences.styleWatch=[this.styleNum]
              } else {
                $localStorage.data.preferences.styleWatch.push(this.styleNum)
              }
          }
      }
}
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>